import React from 'react';
import { metrics } from '../data/profile';
import { SectionHeading } from '../components/SectionHeading';
import { IndustryBackdrop } from '../components/IndustryBackdrop';
import { useCountUp } from '../hooks/useCountUp';
type MetricProps = {
  prefix: string;
  value: number;
  suffix: string;
  label: string;
  featured?: boolean;
};
function Metric({
  prefix,
  value,
  suffix,
  label,
  featured = false
}: MetricProps) {
  const {
    ref,
    value: current
  } = useCountUp(value);
  return <div className={`flex flex-col justify-between border-t border-white/15 pt-7 ${featured ? 'lg:col-span-2 lg:row-span-2 lg:border-t-2 lg:border-gold-400' : ''}`} data-id="element-217" data-mp="1ns62zzdms836">
      <span ref={ref} className={`text-gold-300 ${featured ? 'text-6xl lg:text-8xl' : 'text-4xl lg:text-5xl'}`} data-id="element-218" data-mp="1erhsheng4pv1">
        {prefix}
        {current.toLocaleString('en-US')}
        {suffix}
      </span>
      <p className={`mt-4 leading-relaxed text-slate-300 ${featured ? 'text-xl' : 'text-base'}`} data-id="element-219" data-mp="3bt18b35t4of">
        {label}
      </p>
    </div>;
}
export function Impact() {
  const [featured, ...rest] = metrics;
  return <section className="relative min-h-[70vh] overflow-hidden bg-grass-900 pt-32 pb-24 lg:pb-32" data-id="element-220" data-mp="2lc4qudcrem04">
      <IndustryBackdrop tone="dark" data-id="element-221" data-mp="27cd7ry7dyff9" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-222" data-mp="27fiu55omr37a">
        <SectionHeading eyebrow="IMPACT AND KEY METRICS" title="Value delivered at enterprise scale" tone="dark" data-id="element-223" data-mp="2cb6n7w68ggi2" />

        <div className="mt-16 grid gap-x-12 gap-y-12 lg:grid-cols-4" data-id="element-224" data-mp="22e1wdj1fzwux">
          <Metric {...featured} featured data-id="element-225" data-mp="22geo2nx05ll6" />
          {rest.map(metric => <Metric key={metric.label} {...metric} data-id="element-226" data-mp="1ooi08w2d9xul" />)}
        </div>
      </div>
    </section>;
}